/**
 * Hook to load entities list with async GraphQL support.
 */

import { useState, useEffect } from 'react';
import { getEntities, fetchEntities, type Entity } from '@/lib/data';

const isMockData = import.meta.env.VITE_MOCK_DATA === 'true';

interface EntitiesData {
  entities: Entity[];
  loading: boolean;
  error: string | null;
}

export function useEntities(): EntitiesData {
  const [entities, setEntities] = useState<Entity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        if (isMockData) {
          setEntities(getEntities());
        } else {
          const result = await fetchEntities();
          setEntities(result);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load entities');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return { entities, loading, error };
}
